import { IMySubscription } from '../types/Subscription';

/**
 * Check if user has an active subscription by /mysubscriptions 'active' field
 *
 * @param subscriptions - User subscriptions
 * @returns True if user any subscription has 'active' field true, false otherwise
 */
function checkSubscriptionByActive(subscriptions: IMySubscription) {
  if (subscriptions) {
    const allSubscriptions = Object.values(subscriptions).flat();
    const isSubscriptionActive = allSubscriptions.some(
      (subscription) => subscription?.active === true
    );
    return isSubscriptionActive;
  } else {
    return false;
  }
}

/**
 *  Check if user has an active subscription by /user 'endDateTrialTime' field
 *
 * @param endDateTrialTime - User end date trial time (epoch)
 * @returns True if user end date time is in future, false otherwise
 */
function checkSubscriptionByEndDateTrialTime(endDateTrialTime: number) {
  const currentEpoch = Date.now();

  if (currentEpoch < endDateTrialTime) {
    return true;
  } else {
    return false;
  }
}

/**
 *  Check if user has an active subscription
 *
 * @param subscriptions - User subscriptions
 * @param endDateTrialTime - User end date trial time (epoch)
 * @returns True if user has an active subscription, false otherwise
 */
export function checkUserSubscription(
  subscriptions: IMySubscription,
  endDateTrialTime: number
) {
  let isSubscriptionActive: boolean = false;

  isSubscriptionActive = checkSubscriptionByActive(subscriptions);

  // If no subscription was found, also check by endDateTrialTime (Free trial case)
  if (!isSubscriptionActive) {
    isSubscriptionActive = checkSubscriptionByEndDateTrialTime(
      endDateTrialTime
    );
  }

  return isSubscriptionActive;
}
